import React, { useState, useCallback, useMemo } from "react";
import { ContextMessages } from "./messagesContext";

const MESSAGE_LIFETIME = 5000; // мс до автоскрытия тоста

let messageLastId = 0;

export default function ProviderMessages({ children }) {
    const [messages, setMessages] = useState([]);

    const removeMessage = useCallback((id) => {
        setMessages((previous) => previous.filter((message) => message.id !== id));
    }, []);

    // type — 'success' | 'warning' | 'error'; зовётся и из UI, и из моделей (ApiInit.addMessages)
    const addMessage = useCallback((text, type = 'success') => {
        messageLastId += 1;
        const id = messageLastId;
        setMessages((previous) => [...previous, { id, text, type }]);
        setTimeout(() => removeMessage(id), MESSAGE_LIFETIME);
    }, [removeMessage]);

    const value = useMemo(
        () => ({ messages, addMessage, removeMessage }),
        [messages, addMessage, removeMessage],
    );

    return <ContextMessages.Provider value={value}>{children}</ContextMessages.Provider>;
}
